import { Outlet } from 'react-router-dom'

import { NotFound } from '@factorialco/deprecated-design-system'

import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { PayrollIncidencesSettings } from 'modules/payroll_bundle/components/PayrollIncidencesSettings'
import { useInhousePayroll } from 'modules/payroll_bundle/hooks/useInhousePayroll'
import PayrollPaywallGuard from 'modules/payroll_bundle/pages/PayrollPaywallGuard'

const IncidencesPage = () => {
  const { hasInhousePayroll } = useInhousePayroll()
  if (!hasInhousePayroll && !hasFeature('factorial_professionals')) {
    return (
      <NotFound
        title={i18n.t('errors.page_not_found.title')}
        description={i18n.t('errors.page_not_found.description')}
      />
    )
  }

  return (
    <PayrollPaywallGuard>
      <PayrollIncidencesSettings />
      <Outlet />
    </PayrollPaywallGuard>
  )
}

export default IncidencesPage
